
import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon, MessageSquare } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { useNavigate } from "react-router-dom";

export function ElevenLabsConfigTab() {
  const [selectedVoice, setSelectedVoice] = useState("21m00Tcm4TlvDq8ikWAM"); // Rachel voice ID
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <Alert className="bg-blue-50 border-blue-200">
        <InfoIcon className="h-4 w-4 text-blue-700" />
        <AlertDescription className="text-blue-700">
          ElevenLabs integration allows your AI to conduct screening calls with lifelike voices.
          Configure your API key in the Integrations section.
        </AlertDescription>
      </Alert>
      
      <div className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label htmlFor="voice">Default Voice</Label>
          <Select value={selectedVoice} onValueChange={setSelectedVoice}>
            <SelectTrigger id="voice">
              <SelectValue placeholder="Select voice" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="21m00Tcm4TlvDq8ikWAM">Rachel (Professional)</SelectItem>
              <SelectItem value="AZnzlk1XvdvUeBnXmlld">Domi (Friendly)</SelectItem>
              <SelectItem value="EXAVITQu4vr4xnSDxMaL">Sarah (Enthusiastic)</SelectItem>
              <SelectItem value="MF3mGyEYCl7XYWbV9V6O">Adam (Authoritative)</SelectItem>
              <SelectItem value="TxGEqnHWrfWFTfGW9XjX">Josh (Conversational)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">
            Select the default voice to be used for AI screening calls
          </p>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="model">Voice Model</Label>
          <Select defaultValue="eleven_multilingual_v2">
            <SelectTrigger id="model">
              <SelectValue placeholder="Select model" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="eleven_multilingual_v2">Eleven Multilingual v2 (High Quality)</SelectItem>
              <SelectItem value="eleven_turbo_v2">Eleven Turbo v2 (Fast)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">
            Select the ElevenLabs model to use for voice generation
          </p>
        </div>
        
        <Button 
          variant="outline" 
          onClick={() => navigate('/integrations?tab=elevenlabs')}
          className="w-full mt-2"
        >
          <MessageSquare className="mr-2 h-4 w-4" />
          Configure ElevenLabs API Key
        </Button>
      </div>
    </div>
  );
}
